import { render } from "./IdentityValidation.vue?vue&type=template&id=f6cef632"
import script from "./IdentityValidation.vue?vue&type=script&lang=js"
export * from "./IdentityValidation.vue?vue&type=script&lang=js"

import "./IdentityValidation.vue?vue&type=style&index=0&id=f6cef632&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__